import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate,useLocation  } from "react-router-dom";
import Loader from "../Loader";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken') || null);




  const [user, setUser] = useState(() => {
    // Retrieve user from localStorage if available
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  });
  const navigate = useNavigate();
  const location = useLocation(); // This ensures we're using React Router's location

  const login = (token, userData) => {
    const formattedUserData = { id: userData }; // Convert string to object
  // debugger
    setAuthToken(token);
    setUser(formattedUserData); // Store as an object
  
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(formattedUserData));
  
    navigate('/admin');
  };

  // Logout handler
  const logout = () => {
    setAuthToken(null);
    setUser(null);
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");

    navigate("/");
    // window.location.reload();
  };
  useEffect(() => {
    const protectedRoutes = ["/admin", "/admin/users", "/admin/blog"];
    
    // Redirect to login only if trying to access a protected route
    if (!authToken && protectedRoutes.includes(location.pathname)) {
      navigate("/login");
    }
  }, [authToken, location.pathname, navigate]);

  
  return (
    <AuthContext.Provider value={{ user, login, logout,authToken,
      user,
      login,
      loader,
      setLoader,
      logout,
       }}>
      {children}
      {loader && <Loader />}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
// export const useAuth = () => useContext(AuthContext);
